export const forwarderColors = {
  genio: '#6185DB',
  manual: '#BEAEED',
  prospected: '#EFDE72',
  noExecutive: '#737373',
}
